import { ConfigState } from 'reducers/configReducer';
import { ResetUrlModel } from 'models';
import { AppStore } from '../store';

export function selectConfig(store: AppStore): ConfigState {
  return store.config;
}

export function selectResetUrl(store: AppStore, locale?: string): string | undefined {
  return selectConfig(store).resetUrl?.find((item: ResetUrlModel) => item.locale === locale)?.url;
}

export function selectApiBaseUrl(store: AppStore): string | undefined {
  return selectConfig(store).apiBaseUrl;
}

export function selectChatbotSecret(store: AppStore): string | undefined {
  return store.config.chatbotSecret;
}
